import PatcraftApi from '../../../scripts/patcraft-api';

const state = () => ({
  tray: {
    name: "",
    data: {},
    order: [],
    downloadData:{}
  },
  trayEdit: {
    name: "",
    data: {},
    order: [],
    DeleteItem:[]
  },

  newTrayAdded: {
    name: "",
    data: {},
    order: [],
    DeleteItem:[]
  },
  filtersModalOpened: false,
  selectedTile: '',
  items: [],
  pageNumber: 1,
  pageSize: 10,
  totalPages: 0,
  isFetching: false,
  premixes: [],
  tabName:"",
  itemsData:[]
});

// Getters
const getters = {
  trayData: (state) => {
    return state.tray.data;
  },
  trayDataDownload: (state) => {
    return state.tray.downloadData;
  },
  trayOrders: (state) => {
    return state.tray.order;
  },
  isFiltersModalOpened: (state) => {
    return state.filtersModalOpened;
  },
  trayName: (state) => {
    return state.tray.name;
  },
  getPdmsLinks: (state) => {
    let items = [];
    Object.keys(state.tray.data).forEach((id) => {
      let item = state.tray.data[id];
      if (item.pdmsLink) items.push(item);
    });

    return items;
  },
  tray: (state) => {
    return state.tray;
  },
  selectedTile: (state) => {
    return state.selectedTile;
  },
  items: (state) => {
    return state.items;
  },
  pageNumber: (state) => {
    return state.pageNumber;
  },
  pageSize: (state) => {
    return state.pageSize;
  },
  isFetching: (state) => {
    return state.isFetching
  },
  showLoadMore: (state) => {
    return (state.totalPages > state.pageNumber) || (state.isFetching && state.items.length === 0)
  },
  premixes: (state) => {
    return state.premixes;
  },
  trayEditedData:(state)=>{
    return state.trayEdit.data;
  },
  trayRemovedItems:(state)=>{
    return state.trayEdit.DeleteItem
  },
  trayAddedNewData:(state)=>{
    return state.newTrayAdded.data;
  },
  gettabName:state=>{
    return state.tabName
  },
  getitemsData:state=>{
    return state.itemsData
  }
};

// Mutations
const mutations = {
  setFiltersModalOpened(state, { value }) {
    state.filtersModalOpened = value;
  },
  trayOrderAddItem(state, { id }) {
    state.tray.order = [...state.tray.order, id];
  },
  trayOrderDeleteItem(state, { id }) {
    state.tray.order = state.tray.order.filter((ord) => ord !== id);
  },
  trayDataAddItem(state, { id, newItem }) {
    state.tray.data = {
      ...state.tray.data,
      [id]: newItem
    };
  },
  updateTrayItem(state, { id, updatedItem }) {
      if (state.tray && state.tray.data) {
        // Check if tray and data objects exist
        if (id in state.tray.data) {
          state.tray.data[id] = updatedItem;
          state.tray.downloadData = state.tray.data
          state.tray.data = state.tray.data
        }
      }
  },
  clearDownloadDataTrayData(state) {
      state.tray.downloadData = {}
  },
  newDataAddedInTray(state, { id, newItem }) {
    state.newTrayAdded.data = {
      ...state.newTrayAdded.data,
      [id]: newItem
    };
  },
  newDataDeltededFromTray(state, { id }) {
    const newData = { ...state.newTrayAdded.data };
     delete newData[id];
    state.newTrayAdded.data = { ...newData }
  },

  trayDataEditAddItem(state, { id, newItem }) {
    state.trayEdit.data = {
      ...state.trayEdit.data,
      [id]: newItem
    };
  },

  trayDataDeleteItem(state, { id }) {
    const newData = { ...state.tray.data };
     delete newData[id];
    state.tray.data = { ...newData };
  },

  trayDataEditDeleteItem(state, { id }) {
    const newData = { ...state.trayEdit.data };
    state.trayEdit.DeleteItem.push(...Object.values(newData)?.filter(item=> item?.id === id))
    delete newData[id];
    state.trayEdit.data = { ...newData };

  },
  loadTray(state, { data }) {
    state.tray = { ...data };
  },
  startOver(state) {
    state.tray = {
      name: state.tray.name,
      data: {},
      downloadData: {},
      order: [],
    }
  },
  toggleSelectedTile(state, { id }) {
    state.selectedTile = id;
  },
  setResults(state, { results }) {
    if (state.pageNumber > 1) {
      state.items = [
        ...state.items,
        ...results
      ]
    } else {
      state.items = [...results];

    }
  },
  setPremixes(state, { results }) {
    state.premixes = [...results]
  },
  setPageNumber(state, { page }) {
    state.pageNumber = page;
  },
  setIsFetching(state, { value }) {
    state.isFetching = value;
  },
  setTabName(state, value ) {
    state.tabName = value;
  },
  setTotalPages(state, { pages }) {
    state.totalPages = pages;
  },
  setItemsData(state, itemsData) {
    state.itemsData = itemsData;
  },
};

// Actions
const actions = {
  fetchPremixes({ commit }, data){
    PatcraftApi.searchVirtualTray(data).then((res) => {
      let premixData = [];
      res.data.items.forEach(element => {
        let newPremix = ({
          'name': element.colorName,
          'data': {},
          'order': [],
          'imagePath': element.imagePath
        });
        element.premixProducts.forEach(p => {
          let id = `${p.sellingStyleNumber}-${p.colorNumber}`;
          newPremix.data[id] = {
            ...p,
            "hexColor": p.hex ? "#" + p.hex : p.hex
          };
          newPremix.order.push(id);
        });
        premixData.push(newPremix);
      });
      commit('setPremixes', { results: [...premixData] });
    }).catch((error) => {
      console.log(error);
    });
  },
  updateCartCountInHeader({ commit, state }, totalCount) {
    let type = 1;
    let cartCountElement = document.getElementsByClassName(
      "nav-top-customer-link-with-number-indicator"
    )[0];
    if (!cartCountElement) {
      type = 0;
      cartCountElement = document.getElementsByClassName(
        "nav-top-customer-link-with-number-indicator-empty"
      )[0];
    }

    if (!type) {
      cartCountElement.classList.add(
        "nav-top-customer-link-with-number-indicator"
      );
      cartCountElement.classList.remove(
        "nav-top-customer-link-with-number-indicator-empty"
      );
    }
    cartCountElement.innerHTML = totalCount;
  },
  async fetchResults({ commit, state, dispatch }, data) {
    if (state.isFetching) {
      return;
    }

    dispatch('setIsFetching', true);

    if (state.pageNumber === 1) {
      dispatch('setResults', []);
      PatcraftApi.getVTFilters({ filter: { ...data.filter, PageSize: 0 } })
        .then((res) => {
          dispatch('filters/updateFilterOptions', { filters: [...res.data] }, { root: true });
        })
        .catch((err) => {
          console.log(err);
        });
    }
    const encodedSearchTerm = data.filter?.SearchTerm ? encodeURIComponent(data.filter?.SearchTerm?.trim()) : "";

    data.filter.SearchTerm = encodedSearchTerm;

    await PatcraftApi.searchVirtualTray(data)
      .then((res) => {
        commit('setResults', { results: [...res.data.items] });
        commit('setTotalPages', { pages: res.data.totalPages });
        dispatch('setIsFetching', false);
      })
      .catch((error) => {
        console.log(error);
        dispatch('setIsFetching', false);
      });
  },

  setFiltersModalOpened({ commit }, value) {
    commit('setFiltersModalOpened', { value });
  },
  trayOrderAddItem({ commit }, id) {
    commit('trayOrderAddItem', { id });
  },
  trayOrderDeleteItem({ commit }, id) {
    commit('trayOrderDeleteItem', { id });
  },
  trayDataAddItem({ commit }, payload) {
    commit('trayDataAddItem', payload);
  },
  newDataAddedInTray({ commit }, payload) {
    commit('newDataAddedInTray', payload);
  },
  newDataDeltededFromTray({ commit }, id) {
    commit('newDataDeltededFromTray', {id});
  },
   trayNewDataAdded({ commit }, payload) {
    commit('trayNewDataAdded', payload);
  },
  trayDataEditAddItem({commit}, payload) {
    commit('trayDataEditAddItem', payload);
  },

  trayDataDeleteItem({ commit }, id) {
    commit('trayDataDeleteItem', { id });
  },
  trayDataEditDeleteItem({ commit }, id) {
    commit('trayDataEditDeleteItem', { id });
  },
  loadTray({ commit }, data) {
    commit('loadTray', { data });
  },
  startOver({ commit }) {
    commit('startOver');
  },
  toggleSelectedTile({ commit }, id) {
    commit('toggleSelectedTile', { id });
  },
  setPageNumber({ commit }, page) {
    commit('setPageNumber', { page })
  },
  setResults({ commit }, results) {
    commit('setResults', { results })
  },
  setPremixes({ commit }, results) {
    commit('setPremixes', { results })
  },
  setIsFetching({ commit }, value) {
    commit('setIsFetching', { value })
  },
  setTabName({ commit }, value) {
    commit('setTabName',  value )
  },
  updateItemsData({ commit }, value) {
    commit('setItemsData',  value )
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
